import CreateRubricView from "@features/tools/view/rubric-view/create-rubric-view";

const CreateRubric = () => {
  return <CreateRubricView />;
};

export default CreateRubric;
